import { useEffect } from "react";
import { getHub } from "../../core/Global";


/**
 * Growth signals: the moments only the browser sees -- an upgrade button clicked, a locked
 * feature opened. They feed the free-accounts report and the in-product offers that will be
 * built on them (spec A10).
 *
 * Nothing waits for them and nothing is told if one is lost: sent, never awaited, and every
 * failure swallowed, so a page behaves exactly as it would without them.
 */

export type GrowthKind = "upgrade_clicked" | "paywall"
export type GrowthFeature = "call_recording" | "extra_users" | "masked_job_calls" | "whatsapp" | "telegram" | "plan"

export const trackGrowth = (kind: GrowthKind, feature?: GrowthFeature, detail?: string) => {
    try {
        getHub().Post("/accounts/growth/track", { kind, feature, detail }, () => { }, () => { });
    }
    catch { }
}

/** The add-on keys the subscription page uses, as the feature a signal is about. */
export const growthFeatureOf = (addonKey?: string): GrowthFeature | undefined => {
    switch (addonKey) {
        case "whatsapp": return "whatsapp";
        case "telegram": return "telegram";
        case "extensions": return "masked_job_calls";
        case "recording": return "call_recording";
        case "extra-users": return "extra_users";
        default: return undefined;
    }
}


/**
 * Sends one signal when it first shows -- dropped inside the notice that says something is
 * locked. Renders nothing.
 */
export default function GrowthSignal(props: { kind: GrowthKind, feature?: GrowthFeature, detail?: string }) {
    useEffect(() => {
        trackGrowth(props.kind, props.feature, props.detail);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}
